import classNames from 'classnames'
import MessageCenter from 'components/global-nav/components/MessageCenter'
import { useCallback, useState } from 'react'
import { Badge } from 'react-bootstrap'
import { Inbox } from 'components/global-nav/components/MessageCenter/types'
import { MessageCenterContext } from 'components/global-nav/components/MessageCenter/contexts'
import MessageCenterDropdownButton from 'components/global-nav/components/MessageCenterDropDownButton/MessageCenterDropdownButton'
import css from './MessageCenterMenu.scss'

interface MessageCenterMenuProps {
  c6UnifiedSearchPhase0Variant: boolean
}

const parseDate = (val: Date | string | null | undefined) => {
  if (!val) return null
  if (val instanceof Date) return val.getTime()
  return Date.parse(val)
}

const MessageCenterMenu = ({
  c6UnifiedSearchPhase0Variant,
}: MessageCenterMenuProps) => {
  const [hasUnseenMessages, setHasUnseenMessages] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleInboxChanged = useCallback(
    (inbox: Inbox) => {
      const { lastViewedAt, messages } = inbox
      setHasUnseenMessages(
        !!messages?.some((message) => {
          if (!lastViewedAt) return true
          const lastViewed = parseDate(lastViewedAt)
          const createdAt = parseDate(message.createdAt)
          return lastViewed && createdAt && lastViewed < createdAt
        })
      )
    },
    [setHasUnseenMessages]
  )

  const handleInboxOpened = () => {
    if (document && document.body) {
      document.body.className += document.body.className.length
        ? ' inbox-open'
        : 'inbox-open'
    }
    setMenuOpen(true)
  }

  const handleInboxClosed = () => {
    if (document && document.body) {
      document.body.className = document.body.className.replace(
        / ?inbox-open/,
        ''
      )
    }
    setMenuOpen(false)
  }

  const handleVisibilityToggled = () => {
    const isOpen = !menuOpen
    if (isOpen) {
      handleInboxOpened()
    } else {
      handleInboxClosed()
    }
  }

  const title = (
    <div className="flex-row pull-left">
      <span
        className={classNames(css.bellIcon, {
          [css.GlobalNav__BellIcon]: c6UnifiedSearchPhase0Variant,
        })}
      >
        {hasUnseenMessages && (
          <span
            className={classNames({
              [css.UnreadMessagesBadge__Container]:
                !c6UnifiedSearchPhase0Variant,
              [css.UnreadMessagesBadge__Container__Phase0]:
                c6UnifiedSearchPhase0Variant,
            })}
            data-testid="unseen-messages-badge"
          >
            <Badge bsClass={css.UnreadMessagesBadge}>&nbsp;</Badge>
          </span>
        )}
      </span>
    </div>
  )

  return (
    <MessageCenterContext.Provider value={{ isOpen: menuOpen }}>
      <MessageCenterDropdownButton
        pullRight
        aria-label="message center"
        bsStyle="nav-link"
        data-testid="message-center"
        id="message-center"
        title={title}
        onClick={handleVisibilityToggled}
        onClickAway={handleInboxClosed}
        onSelect={handleInboxClosed}
      >
        <MessageCenter onInboxChanged={handleInboxChanged} />
      </MessageCenterDropdownButton>
    </MessageCenterContext.Provider>
  )
}

export default MessageCenterMenu
